"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerInfo = void 0;
const vue_1 = require("vue");
const PlayerResources_1 = require("./PlayerResources");
const PlayerTags_1 = require("./PlayerTags");
const PlayerStatus_1 = require("./PlayerStatus");
const utils_1 = require("../../utils/utils");
exports.PlayerInfo = vue_1.default.component('player-info', {
    props: {
        player: {
            type: Object,
        },
        activePlayer: {
            type: Object,
        },
        firstForGen: {
            type: Boolean,
        },
        actionLabel: {
            type: String,
        },
        playerIndex: {
            type: Number,
        },
        hideZeroTags: {
            type: Boolean,
        },
    },
    components: {
        'player-resources': PlayerResources_1.PlayerResources,
        'player-tags': PlayerTags_1.PlayerTags,
        'player-status': PlayerStatus_1.PlayerStatus,
    },
    methods: {
        getClasses: function () {
            const classes = ['player-info'];
            return classes.join(' ');
        },
        getNameAndIconClasses: function () {
            const classes = ['name-and-icon'];
            classes.push(utils_1.playerColorClass(this.player.color, 'bg_transparent'));
            return classes.join(' ');
        },
        getPlayerCorpClasses: function () {
            const classes = ['player-corp'];
            classes.push(utils_1.playerColorClass(this.player.color, 'bg_transparent'));
            return classes.join(' ');
        },
        getPlayerStatusAndResClasses: function () {
            const classes = ['player-status-and-res'];
            return classes.join(' ');
        },
        getInfoBottomClasses: function () {
            const classes = ['player-info-bottom'];
            classes.push(utils_1.playerColorClass(this.player.color, 'bg_transparent'));
            return classes.join(' ');
        },
        getIsActivePlayer: function () {
            return this.player.color === this.activePlayer.color;
        },
    },
    template: `
      <div :class="getClasses()">
        <div class="player-info-top">
            <div :class="getNameAndIconClasses()">
              <div class="player-info-name">{{ player.name }}</div>
              <div class="icon-first-player" v-if="firstForGen && activePlayer.players.length > 1"></div>
            </div>
            <div v-for="card in player.corporationCards" :title="card.name" :class="getPlayerCorpClasses()">{{ card.name }}</div>
            <div class="player-discounts-background" />
        </div>
        <div :class="getInfoBottomClasses()">
          <div :class="getPlayerStatusAndResClasses()">
            <player-status :player="player" :activePlayer="activePlayer" :firstForGen="firstForGen" v-trim-whitespace :actionLabel="actionLabel" :playerIndex="playerIndex"/>
            <player-resources :player="player" v-trim-whitespace />
          </div>
          <player-tags :player="player" v-trim-whitespace :isActivePlayer="getIsActivePlayer()" :hideZeroTags="hideZeroTags" />
        </div>
      </div>
    `,
});
//# sourceMappingURL=PlayerInfo.js.map